module.exports = __webpack_public_path__ + "media/images/weather/53_night-ef48388d80497feee739167d83305d32.png";